export default "__VITE_ASSET__DXdELpZh__"